// ErrorDialog.js
import React from "react";
import { Typography } from "@mui/material";
const styles = {
  dialogfooter: {
    display: "flex",
    justifyContent: "center",
    borderTop: "1px solid lightgrey",
    padding: "3px",
  },
  dialogbtn: {
    backgroundColor: "transparent",
    color: "#376EEE",
    fontSize: "16px",
  },
};

const ErrorMessages = ({ errorMessage, errorFiles }) => {
  return (
    <div>
      {/* <span variant="h7" gutterBottom>
        Some files could not be uploaded:
      </span> */}

      {/* <Typography variant="h6" gutterBottom sx={{ paddingTop: "20px" }}>
        {errorFiles.map((file, index) => (
          <Typography variant="h6" key={index} component="li">
            {file.name}
          </Typography>
        ))}
      </Typography> */}

      <Typography style={{ paddingLeft: "20px" }} paragraph>
        {errorMessage}
      </Typography>
    </div>
  );
};

export default ErrorMessages;
